import getQueryParam from '../formats/getQueryParam';
const availableLanguages = ['en', 'es'];
const isSupportedLanguage = (lang) => availableLanguages.includes(lang);
/**
 * This helper reads the language from either local storage or url query param.
 */
export default function getLanguageFromStorage() {
    const localeFromParam = getQueryParam('ui_locales');
    const slicedLocaleFromParam = localeFromParam
        ? localeFromParam.slice(0, 2)
        : '';
    const languageFromParam = getQueryParam('lang');
    const languageFromLocalStorage = localStorage.getItem('language');
    const possibleLanguageParams = [
        slicedLocaleFromParam,
        languageFromParam,
        languageFromLocalStorage
    ];
    const language = possibleLanguageParams.find(isSupportedLanguage) || 'en';
    return language;
}
